// extracted by mini-css-extract-plugin
module.exports = {"SquareBadge":"SquareBadge_SquareBadge__1spiU"};